import React, { Dispatch, SetStateAction, useEffect } from 'react';
import GoogleSignInScript from '../../head/GoogleSignInScript';
import styles from './GoogleSignInButton.module.css';
import GoogleToken from '../../utils/jwt/GoogleToken';
import { GOOGLE_CLIENT_ID } from '../../constants';
import useWindowSize from '../../utils/useWindowSize';

function GoogleSignInButton({ setoauthJWT } : {
  setoauthJWT: Dispatch<SetStateAction<GoogleToken | null>>
}) {
  const size = useWindowSize();

  function renderButton() {
    if (window.google) {
      const width = size?.width || window?.innerWidth;
      // window.google?.accounts?.id?.prompt(); // also display the One Tap dialog
      window.google?.accounts?.id?.renderButton(
        document.getElementById('buttonDiv'),
        {
          theme: 'filled_blue',
          size: 'large',
          shape: 'pill',
          width: width > 480 ? 400 : width - 50,
        },
      );
    }
  }

  useEffect(() => {
    renderButton();
  }, [size?.width]);

  function handleCredentialResponse(response: any) {
    const credJWT = new GoogleToken(response.credential);
    setoauthJWT(credJWT);
  }

  function loadGoogleSignIn() {
    if (window.google) {
      window.google?.accounts?.id?.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: handleCredentialResponse,
        auto_select: false,
        prompt_parent_id: 'oneTap',
      });
    }
  }

  useEffect(() => {
    if (window && typeof window !== 'undefined') {
      const googleScript = document.getElementById('google-sign-in-script');

      if (window?.google) {
        loadGoogleSignIn();
        renderButton();
      }
      googleScript?.addEventListener('load', () => {
        loadGoogleSignIn();
        renderButton();
      });
    }
  }, []);

  return (
    <>
      <GoogleSignInScript />
      <div id="buttonDiv" className={styles.button} />
    </>
  );
}

export default GoogleSignInButton;
